import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const BankAccounts = React.lazy(() => import('./index'));
const BankAccountTable = React.lazy(() => import('./bankAccountTable'));
const BankAccount = React.lazy(() => import('./bankAccount'));
const BankAccountDetail = React.lazy(() => import('./bankAccountDetail'));
const AddNewBankAccount = React.lazy(() => import('./addNewBankAccount'));
const EditBankAccount = React.lazy(() => import('./editBankAccount'));

export const useBankAccountRoutes = () => {

    return (
        <Route path="bankAccounts" element={<Suspense fallback={<div>منتظر باشید...</div>}><BankAccounts /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><BankAccountTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewBankAccount/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><BankAccount/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><BankAccountDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditBankAccount/></Suspense> } />
            </Route>
        </Route>
    )
}